import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { TeComponent } from './common/te-component';
import { theme } from './common/theme';
import { styleMap } from 'lit/directives/style-map';
import { IconName } from './te-icon';
import './te-text';
import './te-icon';

/** Divider Component */
@customElement('te-divider')
export class TeDivider extends TeComponent {
  static styles = [
    ...TeComponent.styles,
    css`
      .te-divider {
        height: 2px;
        border-radius: 1px;
        max-width: 100%;
      }

      p {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      p::before,
      p::after {
        height: 2px;
        border-radius: 1px;
        content: '';
        flex: 1;
        background: var(--bgcolor, ${theme.colors.shade5});
      }

      span.text-icon {
        display: flex;
        align-items: center;
        background: transparent;
        margin-left: 16px;
        margin-right: 16px;
      }

      div.text-icon {
        display: flex;
        align-items: center;
      }

      .text-icon te-text + te-icon {
        margin-left: 8px;
      }

      .default-container > div {
        margin-bottom: 8px;
      }

      .default-container > div:only-child {
        margin-bottom: 0px;
      }
    `,
  ];

  /** Color of the divider */
  @property({ type: String }) dividerColor = theme.colors.shade5.toString();
  /** Text value of divider */
  @property({ type: String }) text = '';
  /** Color of text and icon */
  @property({ type: String }) textColor = theme.colors.text.toString();
  /** Text alignment incide divider */
  @property({ type: String }) textAlign: 'left' | 'center' = 'left';
  /** Relative / Exact width for divider */
  @property({ type: String }) width = '100%';
  /** Icon name from icon pack */
  @property() icon?: IconName;

  getDefaultDividerStyle() {
    return {
      background: this.dividerColor,
      width: this.width,
    };
  }

  getCenterDividerStyle() {
    return {
      '--bgcolor': this.dividerColor,
      width: this.width,
    };
  }

  renderTextIcon() {
    return html`
      ${this.text
        ? html`
            <te-text color=${this.textColor}>${this.text}</te-text>
          `
        : null}
      ${this.icon
        ? html`
            <te-icon name=${this.icon} size="12" color=${this.textColor}></te-icon>
          `
        : null}
    `;
  }

  render() {
    if (this.textAlign === 'center') {
      return html`
        <p class="te-divider" style=${styleMap(this.getCenterDividerStyle())}>
          <span class="text-icon">${this.renderTextIcon()}</span>
        </p>
      `;
    }
    return html`
      <div class="default-container">
        <div class="text-icon">${this.renderTextIcon()}</div>
        <div class="te-divider" style=${styleMap(this.getDefaultDividerStyle())}></div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'te-divider': TeDivider;
  }
}
